import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var state = {
  drawer: true,
  setting: false
};
var getters = {
  drawer: function drawer(state) {
    return state.drawer;
  },
  setting: function setting(state) {
    return state.setting;
  }
};
var actions = {
  updateDrawer: function () {
    var _updateDrawer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var commit;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              commit("setDrawer");

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function updateDrawer(_x) {
      return _updateDrawer.apply(this, arguments);
    }

    return updateDrawer;
  }(),
  updateSetting: function () {
    var _updateSetting = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var commit;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              commit("setSetting");

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function updateSetting(_x2) {
      return _updateSetting.apply(this, arguments);
    }

    return updateSetting;
  }()
};
var mutations = {
  setDrawer: function setDrawer(state) {
    state.drawer = !state.drawer;
  },
  setSetting: function setSetting(state) {
    state.setting = !state.setting;
  }
};
export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};